import { useQuery } from "@tanstack/react-query";
import { getSsoConnectedApps } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const CONNECTED_APPS_QUERY_KEY = "SSO_CONNECTED_APPS";

export const connectedAppsKeys = {
  all: [CONNECTED_APPS_QUERY_KEY],
};

export const useConnectedAppsQuery = () =>
  useQuery({
    queryKey: connectedAppsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getSsoConnectedApps()),
    staleTime: MS_TIME.minute,
  });
